import {isDevXd} from "@Common/ui-components/debug/is-dev";
import {entries} from "@Common/utils/objects";

// styleDefaults is not mutated
// styleConfigs is not mutated
// items is MUTATED
export const setDefaultStyle = async (styleDefaults, styleConfigs, items, ccVersion, currentSurfaceName) => {
    let productThemes = [];
    let changedSurfaces = [];
    let ccVersionMajor = +ccVersion?.split(".")[0] || 0;
    let ccVersionMinor = +ccVersion?.split(".")[1] || 0;
    let ccVersionPatch = +ccVersion?.split(".")[2] || 0;
    Object.entries(styleDefaults).forEach(([currentSide, options]) => {
        Object.entries(options).forEach(([styleName, optionName]) => {

            let skipStyle = false;

            if( ccVersionMajor > 7 || ( ccVersionMajor == 7 && ( ccVersionMinor > 1 || ccVersionPatch >= 27 ) ) ) {
                /*Skip setting style manually unless style applies to another surface or multi-tagged. Just
                * rely on applyTheme from CustCanv.
                */
                skipStyle = true;
                let optionKeys = Object.keys(styleConfigs?.[currentSide]?.[styleName]?.[optionName] ?? {});
                items.forEach((item, index)=>{
                    if( item.parentContainer?.parentComponent?.name != currentSurfaceName ) {
                        skipStyle = false;
                    }
                    else if(item.themeBinding?.styles?.length > 1) {
                        let styleRelatedTags = item.themeBinding.styles.filter( e => optionKeys.indexOf(e) !== -1 );
                        if( styleRelatedTags.length > 1 ) skipStyle = false;
                    }
                });
            }
            if( !skipStyle ) {
                /* V7.1.27 sets visible flag based on last tag. Need to prevent setting over it when dealing with multi tags.
                * Handle visibility ourselves. Mixing multi tags fields or applying styles to surfaces not displayed leads
                * to all kinds of issues with visibility. Easier to just handle on our end.
                */
                let preventOverride = false;
                items.forEach((item)=>{
                    let firstTrue = false;
                    entries(styleConfigs?.[currentSide]?.[styleName]?.[optionName] ?? {}).forEach(([tag,values])=>{
                        if ( values.visible !== undefined && item.themeBinding?.styles?.includes(tag) ) {
                            if (!firstTrue && item.visible != values.visible) {
                                item.visible = values.visible === 'true';
                                if( !changedSurfaces.includes(item?.parentContainer?.parentComponent?.name) ) {
                                    changedSurfaces.push(item?.parentContainer?.parentComponent?.name);
                                }
                            }
                            if (!firstTrue) {
                                firstTrue = values.visible === 'true';
                            }
                            if(ccVersionMajor >=7
                                && (ccVersionMinor > 1 || (ccVersionMinor == 1 && ccVersionPatch >= 27) )
                                && item.themeBinding?.styles?.length > 1
                            ) {
                                preventOverride = true;
                            }
                        }
                    });
                });
                if(!preventOverride) {
                    productThemes.push(optionName);
                }
            }
        });
    });
    return [productThemes, changedSurfaces];
}

// items is MUTATED
// styleBindingData is not mutated
export const getBoundData = async (items, bindingData) => {
    items?.forEach( (item) => {
        try{
            let itemSurface = item.parentContainer.parentComponent.name;
            const bindingValue = bindingData[itemSurface]?.[item.name];
            if (bindingValue){
               item["themeBinding"]["styles"] = bindingValue['tags'];
            }
        }
        catch (e){
            isDevXd() ? console.log("Error with binding style tag: ", item) : null;
            isDevXd() ? console.log("err", e) : null;
        }
        return item;
    });
    return items;
};